<script setup lang="ts">
import PdsButton from '@/components/pds/PdsButton.vue';
import PdsModal from '@/components/pds/PdsModal.vue';
import { formatMoney } from '../format';
import type { PdsOrder } from '../types';

defineProps<{ order: PdsOrder }>();
defineEmits<{ close: []; confirm: [] }>();
</script>

<template>
  <PdsModal size="sm" @close="$emit('close')">
    <template #title>Accepter la commande ?</template>
    <template #subtitle>#{{ order.number }} · {{ order.label }}</template>

    <p class="px-5 py-[25px] text-[16px] leading-[1.4]">
      {{ order.items.length }} produit{{ order.items.length > 1 ? 's' : '' }} ·
      {{ formatMoney(order.totalPaidCents) }} payés. Le client est prévenu dès
      que vous acceptez.
    </p>

    <template #footer>
      <PdsButton variant="second" fit @click="$emit('close')">
        Annuler
      </PdsButton>
      <PdsButton class="flex-1" @click="$emit('confirm')">
        Accepter la commande
      </PdsButton>
    </template>
  </PdsModal>
</template>
